import React, { useEffect } from 'react';
import { useState, useRef } from 'react';
import cn from 'classnames';
import Preview from './Preview';
import PreviewGroup, { context } from './PreviewGroup';
import { icons, preview } from './settings.js';

let uuid = 0;
const ImageInternal = ({
  src: imgSrc,
  alt,
  fallback,
  width,
  height,
  // preview,//默认是true
  // placeholder,
  onError: onImageError,
  style,
  className,
  prefixCls = 'ne-image',
  previewPrefixCls = `${prefixCls}-preview`,
  ...otherProps
}) => {
  const {
    isPreviewGroup,
    registerImage,
    setCurrent,
    setShowPreview: setGroupShowPreview,
  } = React.useContext(context);
  const [currentId] = useState(() => {
    return uuid++;
  });
  const { previewMask, icons, previewSrc } = preview;
  const src = previewSrc || imgSrc; // previewSrc这里是undefined呵呵
  const [status, setStatus] = useState('normal');
  const [isShowPreview, setShowPreview] = useState(false);
  const isError = status === 'error';
  const canPreview = !isError;
  const isLoaded = useRef(false);
  const onLoad = () => {
    setStatus('normal');
  };
  const onError = e => {
    if (onImageError) {
      onImageError(e);
    }
    setStatus('error');
  };
  const onPreview = () => {
    if (isPreviewGroup) {
      setCurrent(currentId);
      setGroupShowPreview(true);
    } else {
      setShowPreview(true);
    }
  };
  const onPreviewClose = e => {
    e.stopPropagation();
    setShowPreview(false);
  };
  const getImgRef = () => {};
  const imgCommonProps = {
    alt,
    className: cn(`${prefixCls}-img`, className),
    style: {
      width,
      height,
      ...style,
    },
  };
  const wrapperClass = cn(prefixCls, { [`${wrapperClass}-error`]: isError });
  const mergedSrc = isError && fallback ? fallback : src;

  useEffect(() => {
    const unregister = registerImage(currentId, src);
    return unregister;
  }, []); // Keep order start
  useEffect(() => {
    registerImage(currentId, src, canPreview);
  }, [src, canPreview]); // Keep order end
  return (
    <>
      <div
        className={wrapperClass}
        style={{ width, height }}
        onClick={preview && !isError ? onPreview : () => {}}>
        <img
          {...imgCommonProps}
          ref={getImgRef}
          {...(isError && fallback ? { src: fallback } : { onLoad, onError, src: imgSrc })}
        />
        {/* {canPreview && <div className={cn(`${prefixCls}-mask`)}>{previewMask}</div>} */}
        {!isPreviewGroup && canPreview && (
          <Preview
            prefixCls={previewPrefixCls}
            visible={isShowPreview}
            icons={icons}
            onClose={onPreviewClose}
            src={mergedSrc}
          />
        )}
      </div>
    </>
  );
};
ImageInternal.PreviewGroup = PreviewGroup;
export default ImageInternal;



// WEBPACK FOOTER //
// ./src/image/Image.jsx